!<template>
  <div class="row">
    <!-- <div class="col-12">
      <h2> {{specialityGroup.name}} </h2>
    </div> -->
    <div class="col-lg-3" v-for="speciality in specialityGroup.specialities" :key="speciality._id">
      <card style="
                  height: 100px;
                  cursor: pointer;
                  border-radius: 5px;
                  overflow: hidden;
                " @click.native="selectSpeciality(speciality)">
        <img v-if="!speciality.backgroundImage" src="@/assets/img/cardiology.jpg" style="
                    position: absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    filter: brightness(50%);
                    height: 100%;
                    width: 100%;
                  " />
        <img v-if="speciality.backgroundImage" :src="
                    baseUrl +
                    '/directtelemedicine/file/speciality/' +
                    speciality._id
                  " style="
                    position: absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    filter: brightness(50%);
                    height: 100%;
                    width: 100%;
                  " />
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="card-title mt-3" style="color: #fff; font-size: larger">
              {{ speciality.name }}
            </h6>
          </div>
        </div>

        <!-- <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller;">{{ doctor.specialityText || '--' }}</h6>
                <p class="card-text">{{ $t('message.waiting5') }}: {{ doctor.registration.number }}, {{ doctor.registration.city }}</p>-->
        <p class="card-text">{{ speciality.description || "--" }}</p>
        <!-- <a href="#" class="card-link" style="bottom: 0px;position: absolute;width: 100%">
                                    <n-button type="primary" round="">Book Appointment</n-button>
                </a>-->
      </card>
    </div>

    <div class="col-12" v-if="specialityGroup.specialities && specialityGroup.specialities.length > 0 && specialitiesPagination.totalPages > 1">
      <n-pagination v-if="specialitiesPagination.totalPages > 1" :page-count="specialitiesPagination.totalPages" v-model="specialitiesPagination.pageNumber"></n-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "speciality-group",
  props: {
    specialityGroup: {
      type: Object,
    },
  },

  async mounted() {
    // try {
    //   let domains = await this.$store.dispatch("getTenantDomains");

    // if (domains[window.location.hostname]) {
    //   this.$store.commit("setState", {
    //     stateName: "tenant",
    //     stateValue: domains[window.location.hostname].name,
    //   });
    // } else if (this.$route.params && this.$route.params.tenant) {
    //   this.$store.commit("setState", {
    //     stateName: "tenant",
    //     stateValue: this.$route.params.tenant,
    //   });
    // } else {
    //   this.$store.commit("setState", {
    //     stateName: "tenant",
    //     stateValue: "default",
    //   });
    // } 
    // } catch (error) {
    //     console.log(error);
    // }
  },

  computed: {
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },

  data() {
    return {
      pageNumber: 1,
      totalPages: 0,
      pageSize: 6,
      specialitiesPagination: {
        pageNumber: this.specialityGroup.pageNumber,
        totalPages: this.specialityGroup.totalPages,
        pageSize: this.specialityGroup.pageSize,
      },
      // backgroundImage: require("@/assets/img/bg7.svg"),
    };
  },
  methods: {
    selectSpeciality(speciality) {
      this.$store.commit("setState", {
        stateName: "selectedSpeciality",
        stateValue: speciality,
      });
      this.$router.push("/speciality/" + speciality._id);
    },

    async getSpecialitiesFromGroup() {
      let response = await this.$store.dispatch("getSpecialitiesFromGroup", {
        pageNumber: this.specialitiesPagination.pageNumber,
        pageSize: this.specialitiesPagination.pageSize,
        specialityGroupId: this.specialityGroup._id || "others",
      });
      this.specialityGroup.specialities = response.data;
      this.specialitiesPagination.totalPages = response.totalPages;
    },
  },

  watch: {
    "specialitiesPagination.pageNumber": function () {
      this.getSpecialitiesFromGroup();
    },
  },
};
</script>

<style>
</style>
